import { useParams } from "react-router";
import { useThesaurusCheckTerm } from "@/hooks/api/useThesaurus";
import Layout from "@/components/Layout/Layout";
import NotFound from "@/pages/NotFound/NotFound";
import Block from "@/pages/Block/Block";
import Area from "@/pages/Area/Area";
import Subarea from "@/pages/Subarea/Subarea";
import Loading from "@/components/Loading/Loading";

export default function Content() {
    const { slug } = useParams();
    const { data, error, isLoading } = useThesaurusCheckTerm(slug);

    if (isLoading) return <Layout><Loading /></Layout>;

    if (error || !data?.length) return <NotFound />;

    const parents = JSON.parse(data[0]?.parents).reverse() || [];
    const level = parents.length;
    const id = data[0]?.section_id;
    const termId = data[0]?.term_id;

    if (level === 1) return <Block id={id} termId={termId} slug={slug}/>;
    if (level === 2) return <Area id={id} termId={termId} parent={parents[1].split('_')[1]} slug={slug}/>;
    if (level === 3 || level === 4) return <Subarea id={id} termId={termId} parents={parents}/>;

    return <NotFound />;
}